import { Loader } from '../Loader';

export const configureLoader = () => {
    // ReactWP uses the built-in loader by default.
    // Uncomment this example if you want a v2-like animation flow:
    // keep animating while critical loading is still running,
    // then exit only when window.loader.isLoaded becomes true.
    /*
    */
    Loader.setAnimation(({ gsap, ScrollTrigger, done }) => {
        let tl = gsap.timeline({
            onComplete: () => {
                tl.kill();
                tl = null;

                done();
            }
        });

        tl
        .to({}, .1, {})
        .add(() => {
            if(!window.loader?.isLoaded){
                tl.restart();
                return;
            }
        })
        .to('#loader svg', .6, {
            x: ((930.92 / 1080) * -100) + 'vh',
            y: ((1092.06 / 1080) * -100) + 'vh',
            top: 0,
            left: 0,
            scale: 1,
            rotate: -27,
            ease: 'sine.inOut',
            delay: .4,
        })
        .to('#loader', .4, {
            opacity: 0,
            pointerEvents: 'none',
            ease: 'sine.inOut',
            onStart: () => {
                ScrollTrigger?.refresh();
            }
        });

        return tl;
    });
};
